module.exports = __webpack_public_path__ + "img/IMG_1908.8513bf43.jpg";